import React, {Component} from 'react';
import {  Navbar,  Nav, NavItem } from 'reactstrap';
import { Link, NavLink} from 'react-router-dom';
// import logo from '../logo.png';


class Header extends Component {

    constructor(props){
        super(props);

        this.state = {
            isNavOpen: false,
            active: 'home'
        };
        this.toggleNav = this.toggleNav.bind(this);

    }


    toggleNav() {
        this.setState({
            isNavOpen: !this.state.isNavOpen
        })
    }
  
// color="faded"

    render() {
        return(
            <div className="row container" style={{justifyItems:"center"}}> 
              <div className="sm-4 offset-2 my-4" style={{padding:"12px", lineHeight:"1.5"}}>
                <h2>
                  <Link to="/home" style={{color:"black", fontFamily:"Pangolin"}}><u>Syed Yakoob Shiraz</u></Link>
                  {/* <a href="/home" to="/home" style={{color:"black", fontFamily:"Pangolin"}}><u>Syed Yakoob Shiraz</u></a> */}
                </h2>
              </div>
              <div className="sm-6 my-4 ml-auto" style={{paddingRight:"12px", lineHeight:"1.5"}}>
                <Navbar light expand="xs">
                    <Nav className="ml-auto" navbar style={{fontFamily: 'Montserrat', color:'black'}}>
                      <NavItem style={{padding:"12px", fontSize:"18px", fontWeight: "400", fontFamily: 'Montserrat'}}>
                            <NavLink onClick={this.toggleNav} to="/home" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                              Home
                            </NavLink>
                        </NavItem>
                      <NavItem style={{padding:"12px", fontSize:"18px", fontWeight: "400", fontFamily: 'Montserrat', color:'black'}}> 
                            <NavLink onClick={this.toggleNav} to="/about" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                              About
                            </NavLink>  
                      </NavItem>
                      <NavItem style={{padding:"12px", fontSize:"18px", fontWeight: "400", fontFamily: 'Montserrat'}}>
                          <NavLink onClick={this.toggleNav} to="/projects" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                            Projects
                          </NavLink>
                      </NavItem>
                      <NavItem style={{padding:"12px", fontSize:"18px", fontWeight: "400", fontFamily: 'Montserrat'}}>
                          <NavLink onClick={this.toggleNav} to="/collaborate" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                            Code
                          </NavLink>
                      </NavItem>
                    </Nav>
                </Navbar>
    </div>
              {/* <div className="sm-6 my-4 ml-auto" style={{padding:"12px", lineHeight:"1.5"}}>

              <Navbar  color="faded" light>
              {/* <Collapse isOpen={this.state.isNavOpen} navbar> */}
                {/* <Nav navbar style={{fontFamily: 'Montserrat'}}>
                  <NavItem style={{ fontSize:"21px", fontWeight: "400"}}>
                    <NavLink onClick={this.toggleNav} to="/home" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                      Home
                    </NavLink>
                  </NavItem>
                  <NavItem style={{fontSize:"21px", fontWeight: "400"}}> 
                    <NavLink onClick={this.toggleNav} to="/about" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                      About
                    </NavLink>  
                  </NavItem>
                  <NavItem style={{fontSize:"21px", fontWeight: "400"}}>
                    <NavLink onClick={this.toggleNav} to="/projects" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                      Projects
                    </NavLink>
                  </NavItem>
                  <NavItem style={{fontSize:"21px", fontWeight: "400"}}>
                    <NavLink onClick={this.toggleNav} to="/collaborate" activeStyle={{fontWeight: "bold", color: "#0056b3", borderBottom: "2.5px solid", borderBottomColor: "gray"}} style={{color: 'black', textDecoration: 'none'}}>
                      Collaborate
                    </NavLink>
                  </NavItem>
                </Nav> */}
              {/* </Collapse> */}
            {/* </Navbar>
            </div>  */}

          </div> 
        );
    }
}

export default Header;